import { createFileRoute } from '@tanstack/react-router';
import { Settings2 } from 'lucide-react';
import { Card } from '@/components/Card/Card';
import type { IRelatorioCurvaAbcFiltros } from '@/types/relatorioCurvaAbc';
import './curva-abc.css';

export const Route = createFileRoute('/_authenticated/relatorio/curva-abc/form')({
  component: RelatorioCurvaAbcFormPage,
});

export interface IRelatorioCurvaAbcFormProps {
  filtros: IRelatorioCurvaAbcFiltros;
  isGenerating?: boolean;
  errorMessage?: string;
  onFiltrosChange: (filtros: IRelatorioCurvaAbcFiltros) => void;
  onGenerate: () => void;
}

export function RelatorioCurvaAbcForm({
  filtros,
  isGenerating = false,
  errorMessage,
  onFiltrosChange,
  onGenerate,
}: IRelatorioCurvaAbcFormProps) {
  const handleInputChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>,
  ) => {
    const { name, value } = event.target;
    onFiltrosChange({
      ...filtros,
      [name]: value,
    });
  };

  return (
    <Card className="filter">
      <Card.Header>
        <div className="relatorio-curva-abc-filter-header">
          <Settings2
            size={18}
            aria-hidden="true"
          />
          <h3>Parâmetros do Relatório</h3>
        </div>
      </Card.Header>

      <Card.Content className="filter-card__content">
        <div className="relatorio-curva-abc-filters-grid">
          <div className="input-content">
            <label htmlFor="dataInicio">Data Início</label>
            <input
              type="date"
              id="dataInicio"
              name="dataInicio"
              value={filtros.dataInicio}
              onChange={handleInputChange}
            />
          </div>

          <div className="input-content">
            <label htmlFor="dataFim">Data Fim</label>
            <input
              type="date"
              id="dataFim"
              name="dataFim"
              value={filtros.dataFim}
              onChange={handleInputChange}
            />
          </div>

          <div className="input-content">
            <label htmlFor="tipoMovimentacao">Tipo de Movimentação</label>
            <select
              id="tipoMovimentacao"
              name="tipoMovimentacao"
              value={filtros.tipoMovimentacao}
              onChange={handleInputChange}
            >
              <option value="saida">Saída (Expedição)</option>
              <option value="entrada">Entrada (Recebimento)</option>
            </select>
          </div>

          <button
            type="button"
            className="filter-button"
            onClick={onGenerate}
            disabled={isGenerating}
          >
            <Settings2
              size={16}
              aria-hidden="true"
            />
            {isGenerating ? 'Gerando...' : 'Gerar Relatório'}
          </button>
        </div>

        {errorMessage && (
          <div className="relatorio-curva-abc-message relatorio-curva-abc-message--error">
            {errorMessage}
          </div>
        )}
      </Card.Content>
    </Card>
  );
}

function RelatorioCurvaAbcFormPage() {
  return (
    <div className="relatorio-curva-abc-container">
      <div className="relatorio-curva-abc-content">
        <p className="relatorio-curva-abc-message relatorio-curva-abc-message--info">
          Utilize a listagem principal para gerar e exportar o relatório.
        </p>
      </div>
    </div>
  );
}
